import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';

import CustomAuthLayout from './components/CustomAuth/CustomAuthLayout';
import ManagerLayout from './components/Manager/ManagerLayout';
import NewStockLayout from './components/NewStock/NewStockLayout';
import OrderReceivedLayout from './components/OrderReceived/OrderReceived';
import StockTakeLayout from './components/StockTake/StockTakeLayout';

// eslint-disable-next-line import/first
import 'styles/stocks/layout.scss';

// eslint-disable-next-line react/prefer-stateless-function
class PageContent extends React.Component {
  render() {
    return (
      <section
        className={`page-content stocks ${
          // eslint-disable-next-line no-nested-ternary
          this.props.currentSalon.calendar_mode === 'light'
            ? 'light-class'
            : this.props.currentSalon.calendar_mode === 'dark'
            ? 'dark-class'
            : 'bright-class'
        }`}
      >
        <Switch>
          <Route exact path="/salon/:id/stocks/manager" component={ManagerLayout} />
          <Route exact path="/salon/:id/stocks/usedSoldOverDateRange" component={ManagerLayout} />
          <Route exact path="/salon/:id/stocks/holdingValue" component={ManagerLayout} />
          <Route exact path="/salon/:id/stocks/lastStockMovement" component={ManagerLayout} />
          <Route path="/salon/:id/stocks/stocktake" component={StockTakeLayout} />
          <Route path="/salon/:id/stocks/newstock" component={NewStockLayout} />
          <Route path="/salon/:id/stocks/customauth" component={CustomAuthLayout} />
          <Route path="/salon/:id/stocks/orderReceived" component={OrderReceivedLayout} />
        </Switch>
      </section>
    );
  }
}

function mapStateToProps(state) {
  const { currentSalon } = state;

  return {
    currentSalon,
  };
}

export default connect(mapStateToProps)(PageContent);
